import React from 'react';
import DocTitle from 'react-document-title';
import Login from '../Login';
import Header from '../Header';
import request from 'arcdynamic-request';
import Sidebar from '../Sidebar';
import {browserHistory} from "react-router";
import {backendServicesUrl} from '../../consts/env';
import {isPeakUser} from '../../peak-user';
import {buildAccess} from '../../access-levels';
import {setCurrentAccess, can} from '../../access';
import {landingRoute} from '../../route-access';
import {startPhone, stopPhone} from '../../utils/phone';

export default class Root extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			user: null,
			showMenu: true,
			userData: null,
			isHscUser: null,
			access: null,
		};

		this.setUser = this.setUser.bind(this);
		this.signOut = this.signOut.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
	}

	
    componentDidMount() {
		request(backendServicesUrl, {
			service: 'arcimedes',
			action: 'Authentication.getStatus',
		}).then(res => {
			if (res && res.success) {
				this.setUser(res.data);
			} else {
				this.setUser(false);
			}
		})
	}

	handleKeyDown(e) {
		// Scheme to only show the focus outline when the user has used keyboard navigation to focus an element.
		if (e.key === 'Tab') {
			setTimeout(()=>{
				if (this.activeElement !== document.activeElement) {
					if (this.activeElement) {
						this.activeElement.removeAttribute('data-focused');
					}
					if (document.activeElement) {
						this.activeElement = document.activeElement;
						this.activeElement.setAttribute('data-focused', true);
					}
				}
			}, 0);
		}
	}

	setUser(user) {
		if (user) {
			startPhone();
			request(arc.path.api, {
				service: 'arcimedes',
				action: 'open.User.get',
				params: ['code', 'USERS', {}],
			}).then(res => {
				const userData = (res && res.success && res.data) || null;
				const ext = (userData && userData._ext) || {};
				const email = userData && userData.email;

				// Everything a page may do comes from the member's permissions
				// (GetStatus _ext): pages ask access.js `can` or the helpers in
				// access-levels.js. A member with no level, or one whose level no
				// longer exists, gets the most restrictive value of each.
				const access = buildAccess({
					permissions: ext.PERMISSIONS || {},
					values: ext.PERMISSION_VALUES || {},
					levelCode: ext.ACCESS_LEVEL_CODE || null,
					levelName: ext.ACCESS_LEVEL_NAME || null,
					isFounder: ext.IS_FOUNDER === true,
				}, {
					email,
					memberId: userData && userData.id,
				});
				setCurrentAccess(access);

				this.setState({
					user,
					userData: userData || false,
					isHscUser: isPeakUser(email, ext.IS_AGENT),
					access,
				});

				const onHome = browserHistory.getCurrentLocation().pathname === '/';

				// Peak members land on Peak Stats — when their level lets them open it.
				if (isPeakUser(email, ext.IS_AGENT) && can('peak.stats') && onHome) {
					browserHistory.push({
						pathname: "/stats"
					});
				} else if (onHome) {
					// Where the member's level says to land (Landing page); a level
					// without the Stats Dashboard would land on "Not Authorized", so
					// it is sent to the first page the sidebar offers.
					const landing = landingRoute(can, access.landingPage);
					if (landing) browserHistory.replace({ pathname: '/' + landing });
				}
			}).catch((e) => {
				console.error(e);
				this.setUser(false);
			});
		} else {
			setCurrentAccess(null);
			this.setState({
				user,
				access: null,
				userData: false,
			});
		}
	}

	signOut() {
		stopPhone();
		request(backendServicesUrl, {
			service: 'arcimedes',
			action: 'Authentication.logout',
		});

		setCurrentAccess(null);
		this.setState({
			user: false,
			access: null,
			userData: false,
		});
	}

	render() {
		const { user, userData, isHscUser, access } = this.state;
		if (user === null) return null;
		return (
			<div className='Root' onKeyDown={this.handleKeyDown}>
				<DocTitle title='ICLIMB'/>
				<Sidebar 
					signOut={user ? this.signOut : null} 
					location={this.props.location} 
					pathname={this.props.location.pathname} 
					isHscUser={isHscUser} 
					access={access}
					userData={userData}
				>
                    {
                        user ? React.cloneElement(this.props.children, {userData, access}) : <Login setUser={this.setUser}/>
                    }
				</Sidebar>
			</div>
		);
	}
}